import { defineMessages } from 'react-intl';

export default defineMessages({
  heading: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.heading',
    defaultMessage: 'Other Insurance Coverage',
  },
  hasProvincialHealthCoverage: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.hasProvincialHealthCoverage',
    defaultMessage: 'Do you have provincial health coverage from a Canadian province or territory?',
  },
  provincialHealthProvinceLabel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.provincialHealthProvinceLabel',
    defaultMessage: 'Which Canadian province provides your provincial health care coverage (e.g. MSP, OHIP, AHCIP)?',
  },
  provincialHealthProvinceRequired: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.provincialHealthProvinceRequired',
    defaultMessage: 'Province/Territory is required',
  },
  provincialHealthDownloadButton: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.provincialHealthDownloadButton',
    defaultMessage: 'Download Form',
  },
  hasOtherInsuranceCoverage: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.hasOtherInsuranceCoverage',
    defaultMessage: 'Do you have any other insurance or health coverage that may apply to this claim?',
  },
  yes: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.no',
    defaultMessage: 'No',
  },
  whatTypeOfCoverage: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.whatTypeOfCoverage',
    defaultMessage: 'What type of other insurance coverage do you have?',
  },
  coverageTypeEmployerGroup: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.coverageTypeEmployerGroup',
    defaultMessage: 'Employer or group health plan',
  },
  employerInsuranceCompanyLabel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.employerInsuranceCompanyLabel',
    defaultMessage: 'Insurance Company Name',
  },
  employerInsuranceCompanyRequired: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.employerInsuranceCompanyRequired',
    defaultMessage: 'Insurance Company Name is required',
  },
  employerPolicyGroupNoLabel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.employerPolicyGroupNoLabel',
    defaultMessage: 'Policy or Group No',
  },
  coverageTypeCreditCard: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.coverageTypeCreditCard',
    defaultMessage: 'Credit card insurance coverage',
  },
  creditCardProviderLabel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.creditCardProviderLabel',
    defaultMessage: 'Credit Card Provider',
  },
  creditCardProviderRequired: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.creditCardProviderRequired',
    defaultMessage: 'Credit Card Provider is required',
  },
  creditCardFirst4DigitsLabel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.creditCardFirst4DigitsLabel',
    defaultMessage: 'First 4 digits of card',
  },
  creditCardFirst4DigitsRequired: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.creditCardFirst4DigitsRequired',
    defaultMessage: 'First 4 digits of card is required',
  },
  creditCardFirst4DigitsInvalid: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.creditCardFirst4DigitsInvalid',
    defaultMessage: 'Must be exactly 4 digits',
  },
  creditCardLast4DigitsLabel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.creditCardLast4DigitsLabel',
    defaultMessage: 'Last 4 digits of card',
  },
  creditCardLast4DigitsRequired: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.creditCardLast4DigitsRequired',
    defaultMessage: 'Last 4 digits of card is required',
  },
  creditCardLast4DigitsInvalid: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.creditCardLast4DigitsInvalid',
    defaultMessage: 'Must be exactly 4 digits',
  },
  creditCardInsuranceProviderLabel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.creditCardInsuranceProviderLabel',
    defaultMessage: 'Insurance Provider (if known)',
  },
  coverageTypeAnotherTravel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.coverageTypeAnotherTravel',
    defaultMessage: 'Travel insurance policy from another insurer',
  },
  anotherTravelInsuranceCompanyLabel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.anotherTravelInsuranceCompanyLabel',
    defaultMessage: 'Insurance Company',
  },
  anotherTravelInsuranceCompanyRequired: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.anotherTravelInsuranceCompanyRequired',
    defaultMessage: 'Insurance Company is required',
  },
  anotherTravelPolicyNumberLabel: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.anotherTravelPolicyNumberLabel',
    defaultMessage: 'Policy Number',
  },
  coverageTypeRequired: {
    id: 'fastCover.stepOtherInsuranceCoverageTugo.coverageTypeRequired',
    defaultMessage: 'Please select at least one type of insurance coverage',
  },

});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StepOtherInsuranceCoverage/messages.js